function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ElementModel } from './ElementModel';
import * as Y from 'yjs';
import { chunk } from 'lodash';
import { getStroke } from 'perfect-freehand';
import { EditorConfig } from '../../edit/EditorConfig';
import { removeObserver } from '@netless/forge-room';
export class LaserPointerModel extends ElementModel {
  constructor(clientId, root, scope, liveCursor, removeElement, isPerformanceMode) {
    super(root, scope, liveCursor, isPerformanceMode);
    _defineProperty(this, "item", null);
    _defineProperty(this, "clientId", void 0);
    _defineProperty(this, "sliceBegin", 0);
    _defineProperty(this, "displayStrokeWidth", 8);
    _defineProperty(this, "cachedPoints", null);
    _defineProperty(this, "clearLocalPointsWhenYPointsChange", false);
    _defineProperty(this, "shouldUseLocalPoints", false);
    _defineProperty(this, "localPointsPick", 4);
    _defineProperty(this, "removeElement", void 0);
    _defineProperty(this, "handleLaserPropChange", event => {
      if (!this.item) {
        return;
      }
      for (const [key] of event.changes.keys.entries()) {
        if (key === 'removed') {
          if (this.cachedPoints == null) {
            this.cachedPoints = this.points;
          }
          this.item.onFrame = evt => {
            this.displayStrokeWidth = Math.max(0.1, this.displayStrokeWidth -= 8 / 30);
            if (evt.count >= 20) {
              const points = this.cachedPoints || this.points;
              this.sliceBegin += Math.ceil(points.length / 2 / 20);
            }
            this.onVectorUpdate();
            if (evt.count >= 30) {
              if (this.ownerId === this.clientId) {
                this.removeElement(this.uuid);
              }
            }
          };
        }
      }
    });
    this.clientId = clientId;
    this.removeElement = removeElement;
    if (this.root.doc && !this.root.has('type')) {
      this.root.set('type', 'laser');
    }
    if (this.root.doc && !this.root.has('points')) {
      this.root.set('points', new Y.Array());
    }
    if (this.root.doc && !this.root.has('removed')) {
      this.root.set('removed', false);
    }
  }
  subBindObserver() {
    removeObserver(this.root, this.handleLaserPropChange);
    this.root.observe(this.handleLaserPropChange);
  }
  subDispose() {
    removeObserver(this.root, this.handleLaserPropChange);
  }
  beginRemoveAnimate() {
    this.root.set('removed', true);
  }
  average(a, b) {
    return (a + b) / 2;
  }
  createPath(points) {
    const path = new this.scope.Path();
    const len = points.length;
    if (len < 4) {
      return path;
    }
    let control = new this.scope.Point(0, 0);
    let current = new this.scope.Point(0, 0);
    let a = points[0];
    let b = points[1];
    const c = points[2];
    current = new this.scope.Point(a[0], a[1]);
    path.moveTo(current);
    control = new this.scope.Point(b[0], b[1]);
    current = new this.scope.Point(this.average(b[0], c[0]), this.average(b[1], c[1]));
    path.quadraticCurveTo(control, current);
    for (let i = 2, max = len - 1; i < max; i++) {
      a = points[i];
      b = points[i + 1];
      control = current.multiply(2).subtract(control);
      current = new this.scope.Point(this.average(a[0], b[0]), this.average(a[1], b[1]));
      path.quadraticCurveTo(control, current);
    }
    return path;
  }
  parsePoints(points) {
    return getStroke(points, {
      size: this.displayStrokeWidth,
      smoothing: 0,
      thinning: 0.5,
      streamline: 0,
      simulatePressure: true,
      start: {
        taper: 0,
        cap: true
      },
      end: {
        taper: 0,
        cap: true
      }
    });
  }
  matrixedPoints() {
    const matrix = new this.scope.Matrix(this.pointsMatrix);
    const points = this.cachedPoints || this.points;
    const groupPoints = chunk(points, 2).slice(this.sliceBegin);
    return groupPoints.map(_ref => {
      let [x, y] = _ref;
      return matrix.transform([x, y]);
    }).map(p => [p.x, p.y]);
  }
  getNextSegments() {
    const points = this.parsePoints(this.matrixedPoints());
    const path = this.createPath(points);
    return path.segments;
  }
  onVectorUpdate() {
    if (!this.item) {
      return;
    }
    this.item.removeSegments();
    this.item.addSegments(this.getNextSegments());
  }
  createPaperItem() {
    this.item = new this.scope.Path();
    this.item.strokeCap = 'round';
    this.item.strokeJoin = 'round';
    this.item.strokeScaling = false;
    this.item.strokeColor = new this.scope.Color(this.strokeColor);
    this.item.fillColor = new this.scope.Color(this.strokeColor);
    this.item.addSegments(this.getNextSegments());
  }
  editorConfig() {
    return new EditorConfig();
  }
  vectorKeys() {
    return [];
  }
  styleKeys() {
    return {
      include: [],
      exclude: []
    };
  }
  onStyleKeyUpdate(_key) {
    return;
  }
  liveCursorPoint() {
    const yArray = this.root.get(ElementModel.KEYS.points);
    if (yArray.length < 2) {
      return null;
    }
    const len = yArray.length;
    const point = new this.scope.Point(yArray.get(len - 2), yArray.get(len - 1));
    return point.transform(new this.scope.Matrix(this.pointsMatrix));
  }
}